// eslint-disable-next-line no-shadow
import { Breakpoint } from '@mui/system/createTheme/createBreakpoints';

export enum RequestStatus {
  INIT = 'INIT',
  REQUEST = 'REQUEST',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  RESET = 'RESET',
}

export enum Socials {
  twitter = 'twitter',
  discord = 'discord',
}

export type UIState = Record<string, RequestStatus>;

export type StateWithUIState<P = Record<string, unknown>> = {
  ui: UIState;
} & P;

export type GridBreakpointsType<T> = Partial<Record<Breakpoint, T>>;
